import type { PayloadAction } from '@reduxjs/toolkit'

import type { SignInPayload } from './firebase.types'
import { moduleName } from './firebase.types'

export const actionTypes = {
  BEGIN_SIGN_IN: `${moduleName}/BEGIN_SIGN_IN`,
}

export const beingSignIn = (email: string, password: string): PayloadAction<SignInPayload> => ({
  type: actionTypes.BEGIN_SIGN_IN,
  payload: {
    email,
    password,
  },
})
